// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.planDetails {
  width: 100%;
  height: 100%;
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  position: relative;
  overflow: auto;
}
.planDetails .cDetails {
  height: 100%;
  flex: 1 1 20rem;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.planDetails .cDetails .proceedBtn {
  background-color: var(--AccentColor);
  height: 3rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  gap: 0.5rem;
  font-size: 1.1rem;
  position: sticky;
  top: 0;
}
.planDetails .cDetails .Back {
  width: 4rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--AccentColor);
  cursor: pointer;
  font-size: 0.875rem;
}
.planDetails .cDetails .Back svg path {
  fill: var(--AccentColor);
}
.planDetails .cDetails .detailsForm {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  background-color: var(--Foreground);
  border-radius: 0.5rem;
  padding: 0.6rem;
  overflow-y: auto;
  overflow-x: hidden;
}
.planDetails .cDetails .detailsForm h1 {
  color: var(--TextColor);
}
.planDetails .cDetails .detailsForm .uploadsCont {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.planDetails .cDetails .detailsForm .uploadsCont h1 {
  color: var(--TextColor);
}
.planDetails .cDetails .detailsForm .uploadsCont span {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--AccentColor);
}
.planDetails .cDetails .detailsForm .uploadsCont input[type=file] {
  display: none;
}
.planDetails .cDetails .detailsForm .uploadsCont .upload {
  background-color: var(--Invitation);
  text-align: center;
  padding: 0.9rem 0rem;
  border-radius: 0.5rem;
  color: var(--TextColor);
  cursor: pointer;
}
.planDetails .cDetails .detailsForm .uploadsCont .upload img {
  width: 1.25rem;
  height: 1.25rem;
}
.planDetails .cDetails .detailsForm .uploadsCont .upload .fileNameDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}
.planDetails .cDetails .detailsForm .uploadsCont .uploadedFileName {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}
.planDetails .cDetails .detailsForm .uploadsCont .uploadedFileName p {
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.planDetails .cDetails .detailsForm .textForm {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
.planDetails .cDetails .detailsForm .textForm .inputCont {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  gap: 0.3rem;
  min-height: 3.5rem;
  height: 3.5rem;
}
.planDetails .cDetails .detailsForm .textForm .inputCont label {
  position: absolute;
  visibility: hidden;
  top: 0rem;
  left: 0;
  color: var(--TextColor);
  z-index: 1;
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.6;
  transform: translateY(0%);
  transition: opacity 0.3s ease-in, transform 0.3s ease-in;
}
.planDetails .cDetails .detailsForm .textForm .inputCont input[type=text]:focus + label {
  visibility: visible;
  opacity: 1;
  transform: translateY(15%);
  padding-left: 0.3rem;
}
.planDetails .cDetails .detailsForm .textForm .inputCont input[type=text]:focus::placeholder {
  opacity: 0;
  transition: opacity 0.3s ease-in;
}
.planDetails .cDetails .detailsForm .textForm input {
  border: none;
  outline: none;
  border-bottom: 0.0625rem solid var(--Invitation);
  height: 2rem;
  background-color: transparent;
  text-indent: 0.6rem;
  color: var(--TextColor);
}
.planDetails .cDetails .detailsForm .textForm input::placeholder {
  font-size: 0.9rem;
  font-family: poppins;
  color: var(--TextColor);
}
.planDetails .cDetails .detailsForm .checkBox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-direction: row;
  margin-top: 0.7rem;
  position: relative;
}
.planDetails .cDetails .detailsForm .checkBox label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.planDetails .cDetails .detailsForm .checkBox label input[type=checkbox] {
  height: 0.85rem;
  width: 0.85rem;
  appearance: none;
  border: 0.0625rem solid var(--AccentColor);
  border-radius: 0.15rem;
}
.planDetails .cDetails .detailsForm .checkBox label input[type=checkbox]:checked {
  height: 0.85rem;
  width: 0.85rem;
  appearance: none;
  background-color: var(--AccentColor);
  border-radius: 0.15rem;
}
.planDetails .cDetails .detailsForm .checkBox label input[type=checkbox]:checked::before {
  content: "✔";
  display: block;
  text-align: center;
  color: white;
  font-size: 0.6rem;
}
.planDetails .cDetails .detailsForm .checkBox p {
  color: var(--TextColor);
  font-size: 0.9rem;
  font-weight: 600;
}
.planDetails .cDetails .detailsForm .checkBox svg {
  width: 1.5rem;
  height: 1.5rem;
}
.planDetails .cDetails .detailsForm .checkBox .tooltip {
  position: fixed;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  border: 0.0625rem solid var(--AccentColor);
  background-color: var(--Foreground);
  z-index: 999;
  border-radius: 0.625rem;
  width: 20rem;
  height: 6rem;
  padding: 0.3125rem;
  transform: translateY(-110%);
  transition: 1s ease-in;
}
.planDetails .cDetails .detailsForm .checkBox .tooltip h3 {
  font-size: 0.8rem;
  color: var(--TextColor);
  font-weight: 700;
}
.planDetails .cDetails .detailsForm .checkBox .tooltip p {
  font-size: 0.7rem;
  color: var(--TextColor);
  font-weight: 500;
}
.planDetails .cDetails .detailsForm .checkBox .tooltip img {
  width: 5rem;
  height: 5rem;
  object-fit: contain;
}
.planDetails .cDetails .detailsForm .checkBox .tooltip::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 1rem;
  transform: translateX(50%);
  width: 0;
  height: 0;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-top: 10px solid var(--Foreground);
}
.planDetails .cDetails .detailsForm .checkBox .tooltip::before {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 1rem;
  transform: translateX(50%);
  width: 0;
  height: 0;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
  border-top: 10px solid var(--AccentColor);
}
.planDetails .planContainer {
  height: 100%;
  flex: 3 1 30rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
  gap: 0.6rem;
}
.planDetails .planContainer .proceedButton {
  background-color: var(--AccentColor);
  height: 3rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  gap: 0.5rem;
  font-size: 1.1rem;
  position: sticky;
  top: 0;
  display: none;
}
.planDetails .planContainer .planInnerContainer {
  width: 100%;
  height: 100%;
  flex: 1 1;
  display: flex;
  padding: 0.6rem;
  flex-direction: column;
  gap: 0.6rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.6rem;
  overflow-y: auto;
  overflow-x: hidden;
}
.planDetails .planContainer .planInnerContainer .searchBox {
  padding-right: 0.75rem;
  display: flex;
  width: 100%;
  min-height: 2.5rem;
  align-items: center;
  justify-content: space-between;
  background-color: var(--Foreground);
  border-radius: 0.5rem;
}
.planDetails .planContainer .planInnerContainer .searchBox input {
  border: none;
  outline: none;
  background-color: transparent;
  flex: 1 1;
  padding: 0 0.75rem;
  height: 100%;
  color: var(--TextColor);
}
.planDetails .planContainer .planInnerContainer .searchBox input::placeholder {
  font-size: 0.9rem;
}
.planDetails .planContainer .planInnerContainer .searchBox img {
  max-width: 1.25rem;
  max-height: 1.25rem;
}
.planDetails .planContainer .planInnerContainer .planTypesContainer {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper {
  flex: 1 1;
  width: 100%;
  overflow: auto;
}
.planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
  width: 100%;
  columns: 3;
  column-gap: 1rem;
  overflow: auto;
}

.VeriSavedContainer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 10;
}
.VeriSavedContainer .VeriSaved {
  padding: 1.25rem 3.75rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
  max-width: 37.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}
.VeriSavedContainer .VeriSaved .SuccessBeginVerification {
  max-width: 18.75rem;
  max-height: 18.75rem;
}
.VeriSavedContainer .VeriSaved .SuccessBeginVerification img {
  width: 100%;
  height: 100%;
}
.VeriSavedContainer .VeriSaved h1 {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--TextColor);
}
.VeriSavedContainer .VeriSaved .Hint {
  font-size: 0.875rem;
  text-align: center;
  color: var(--TextColor);
}
.VeriSavedContainer .VeriSaved .CopyOpen {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.5rem;
}
.VeriSavedContainer .VeriSaved .CopyOpen button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  color: var(--AccentColor);
  cursor: pointer;
  width: 7.5rem;
  height: 2rem;
  border-radius: 0.5rem;
}
.VeriSavedContainer .VeriSaved .CopyOpen button a {
  text-decoration: none;
}
.VeriSavedContainer .VeriSaved .CopyOpen button:hover {
  background: rgba(0, 0, 0, 0.0352941176);
}
.VeriSavedContainer .VeriSaved .ButtonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
}
.VeriSavedContainer .VeriSaved .ButtonContainer .Cancel {
  font-size: 0.875rem;
  height: 2.5rem;
  width: 7.5rem;
  color: #979797;
  border: 0.0625rem solid #979797;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
}
.VeriSavedContainer .VeriSaved .ButtonContainer .Cancel:hover {
  background: #ececec;
  color: var(--AccentColor);
}
.VeriSavedContainer .VeriSaved .ButtonContainer .Done {
  font-size: 0.875rem;
  height: 2.5rem;
  width: 7.5rem;
  color: #fff;
  border: 0.0625rem solid var(--AccentColor);
  border-radius: 0.5rem;
  background: var(--AccentColor);
  border: 0.0625rem solid var(--AccentColor);
  cursor: pointer;
}

@media (max-width: 1160px) {
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 2;
  }
}
@media (max-width: 940px) {
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 1;
  }
}
@media (max-width: 850px) {
  .planDetails .cDetails {
    height: auto;
  }
  .planDetails .cDetails .proceedBtn {
    display: none;
  }
  .planDetails .planContainer {
    height: auto;
  }
  .planDetails .planContainer .proceedButton {
    display: flex;
  }
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 2;
  }
}
@media (max-width: 800px) {
  .planDetails .cDetails {
    height: 100%;
  }
  .planDetails .cDetails .proceedBtn {
    display: none;
  }
  .planDetails .planContainer {
    height: 100%;
  }
  .planDetails .planContainer .proceedButton {
    display: flex;
  }
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 2;
  }
}
@media (max-width: 718px) {
  .planDetails .cDetails {
    height: auto;
  }
  .planDetails .cDetails .proceedBtn {
    display: none;
  }
  .planDetails .planContainer {
    height: auto;
  }
  .planDetails .planContainer .proceedButton {
    display: flex;
  }
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 2;
  }
}
@media (max-width: 600px) {
  .planDetails .planContainer .planInnerContainer .planTypesContainer .planTypesWrapper .planTypes {
    columns: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/BeginVerification.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAEF;AADE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAGJ;AAFI;EACE,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;AAIN;AAFI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAIN;AAFQ;EACE,wBAAA;AAIV;AAAI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAEN;AADM;EACE,uBAAA;AAGR;AADM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAGR;AAFQ;EACE,uBAAA;AAIV;AAFQ;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AAIV;AAFQ;EACE,aAAA;AAIV;AAFQ;EACE,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;AAIV;AAHU;EACE,cAAA;EACA,eAAA;AAKZ;AAHU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAKZ;AAFQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAIV;AAFU;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AACM;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;AACR;AAAQ;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAEV;AADU;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,wDAAA;AAGZ;AAAY;EACE,mBAAA;EACA,UAAA;EACA,0BAAA;EACA,oBAAA;AAEd;AAAY;EACE,UAAA;EACA,gCAAA;AAEd;AAEQ;EACE,YAAA;EACA,aAAA;EACA,gDAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;AAAV;AACU;EACE,iBAAA;EACA,oBAAA;EACA,uBAAA;AACZ;AAGM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAAV;AACU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;AACZ;AACU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;AACZ;AAAY;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAEd;AAEQ;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;AAAV;AA+BQ;EACE,aAAA;EACA,cAAA;AA7BV;AAsCQ;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,0CAAA;EACA,mCAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;AArCV;AAsCU;EACE,iBAAA;EACA,uBAAA;EACA,gBAAA;AApCZ;AAsCU;EACE,iBAAA;EACA,uBAAA;EAEA,gBAAA;AArCZ;AAwCU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAtCZ;AAwCU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;AAtCZ;AAyCU;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,0BAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,sCAAA;EACA,yCAAA;AAvCZ;AA6CE;EACE,YAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA5CJ;AA6CI;EACE,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;AA3CN;AA6CI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,qCAAA;EACF,qBAAA;EACA,gBAAA;EACA,kBAAA;AA3CJ;AA4CM;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mCAAA;EACA,qBAAA;AA1CR;AA2CQ;EACE,YAAA;EACA,aAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AAzCV;AA0CU;EACE,iBAAA;AAxCZ;AA2CQ;EACE,kBAAA;EACA,mBAAA;AAzCV;AA4CM;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA1CR;AA2CQ;EACE,SAAA;EACA,WAAA;EACA,cAAA;AAzCV;AA0CU;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAxCZ;;AAiDA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,WAAA;AA9CF;AA+CE;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AA7CJ;AA8CI;EACE,mBAAA;EACA,oBAAA;AA5CN;AA6CM;EACE,WAAA;EACA,YAAA;AA3CR;AA8CI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5CN;AA8CI;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AA5CN;AA8CI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA5CN;AA6CM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;AA3CR;AA4CQ;EACE,qBAAA;AA1CV;AA6CM;EACE,uCAAA;AA3CR;AA8CI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA5CN;AA6CM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;AA3CR;AA6CM;EACE,mBAAA;EACA,yBAAA;AA3CR;AA6CM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,0CAAA;EACA,qBAAA;EACA,8BAAA;EACA,0CAAA;EACA,eAAA;AA3CR;;AAiDA;EAMY;IACE,UAAA;EAnDZ;AACF;AA2DA;EAMY;IACE,UAAA;EA9DZ;AACF;AAsEA;EAEI;IACE,YAAA;EArEJ;EAsEI;IACE,aAAA;EApEN;EAuEE;IACE,YAAA;EArEJ;EAsEI;IACE,aAAA;EApEN;EAyEU;IACE,UAAA;EAvEZ;AACF;AA+EA;EAEI;IACE,YAAA;EA9EJ;EA+EI;IACE,aAAA;EA7EN;EAgFE;IACE,YAAA;EA9EJ;EA+EI;IACE,aAAA;EA7EN;EAkFU;IACE,UAAA;EAhFZ;AACF;AAwFA;EAEI;IACE,YAAA;EAvFJ;EAwFI;IACE,aAAA;EAtFN;EAyFE;IACE,YAAA;EAvFJ;EAyFI;IACE,aAAA;EAvFN;EA4FU;IACE,UAAA;EA1FZ;AACF;AAkGA;EAMY;IACE,UAAA;EArGZ;AACF","sourcesContent":[".planDetails {\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  position: relative;\n  overflow: auto;\n  .cDetails {\n    height: 100%;\n    flex: 1 35rem 20rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n    .proceedBtn {\n      background-color: var(--AccentColor);\n      height: 3rem;\n      border-radius: 0.5rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #ffffff;\n      gap: 0.5rem;\n      font-size: 1.1rem;\n      position: sticky;\n      top: 0;\n    }\n    .Back{\n      width: 4rem;\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n      color: var(--AccentColor);\n      cursor: pointer;\n      font-size: 0.875rem;\n      svg{\n        path{\n          fill: var(--AccentColor);\n        }\n      }\n    }\n    .detailsForm {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 0.6rem;\n      background-color: var(--Foreground);\n      border-radius: 0.5rem;\n      padding: 0.6rem;\n      overflow-y: auto;\n      overflow-x: hidden;\n      h1 {\n        color: var(--TextColor);\n      }\n      .uploadsCont {\n        display: flex;\n        flex-direction: column;\n        gap: 0.3rem;\n        h1{\n          color: var(--TextColor);\n        }\n        span{\n          font-size: 0.75rem;\n          font-weight: 400;\n          color: var(--AccentColor);\n        }\n        input[type=\"file\"] {\n          display: none;\n        }\n        .upload {\n          background-color: var(--Invitation);\n          text-align: center;\n          padding: 0.9rem 0rem;\n          border-radius: 0.5rem;\n          color: var(--TextColor);\n          cursor: pointer;\n          img {\n            width: 1.25rem;\n            height: 1.25rem;\n          }\n          .fileNameDiv {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n            gap: 0.6rem;\n          }\n        }\n        .uploadedFileName {\n          position: relative;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: center;\n          gap: 0.6rem;\n          // z-index: 10;\n          p {\n            max-width: 10rem;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n          }\n        }\n\n      }\n      .textForm {\n        flex: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        overflow: auto;\n        .inputCont {\n          display: flex;\n          flex-direction: column;\n          justify-content: flex-end;\n          position: relative;\n          gap: 0.3rem;\n          min-height: 3.5rem;\n          height: 3.5rem;\n          label {\n            position: absolute;\n            visibility: hidden;\n            top: 0rem;\n            left: 0;\n            color: var(--TextColor);\n            z-index: 1;\n            font-size: 0.7rem;\n            font-weight: 600;\n            opacity: 0.6;\n            transform: translateY(0%);\n            transition: opacity 0.3s ease-in, transform 0.3s ease-in;\n          }\n          input[type=\"text\"] {\n            &:focus + label {\n              visibility: visible;\n              opacity: 1;\n              transform: translateY(15%);\n              padding-left: 0.3rem;\n            }\n            &:focus::placeholder {\n              opacity: 0;\n              transition: opacity 0.3s ease-in;\n            }\n          }\n        }\n        input {\n          border: none;\n          outline: none;\n          border-bottom: 0.0625rem solid var(--Invitation);\n          height: 2rem;\n          background-color: transparent;\n          text-indent: 0.6rem;\n          color: var(--TextColor);\n          &::placeholder {\n            font-size: 0.9rem;\n            font-family: poppins;\n            color: var(--TextColor);\n          }\n        }\n      }\n      .checkBox {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        flex-direction: row;\n        margin-top: 0.7rem;\n        position: relative;\n        label{\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          input[type=\"checkbox\"] {\n            height: 0.85rem;\n            width: 0.85rem;\n            appearance: none;\n            border: 0.0625rem solid var(--AccentColor);\n            border-radius: 0.15rem;\n          }\n          input[type=\"checkbox\"]:checked {\n            height: 0.85rem;\n            width: 0.85rem;\n            appearance: none;\n            background-color: var(--AccentColor);\n            border-radius: 0.15rem;\n            &::before {\n              content: \"✔\";\n              display: block;\n              text-align: center;\n              color: white;\n              font-size: 0.6rem;\n            }\n          }\n        }\n        p {\n          color: var(--TextColor);\n          font-size: 0.9rem;\n          font-weight: 600;\n        }\n        // div{\n        //     position: relative;\n        //     display: flex;\n        //     align-items: center;\n        //     .tooltip {\n        //         // visibility: hidden;\n        //         display: none;\n        //         width: 12rem;\n        //         background-color: black;\n        //         color: #fff;\n        //         text-align: center;\n        //         font-size: .8rem;\n        //         border-radius: .3rem .3rem .3rem 0rem;\n        //         padding: .3rem;\n        //         position: absolute;\n        //         transform: translateX(15%);\n        //         opacity: 0;\n        //         transition: opacity 0.3s;\n        //         bottom: 100%;\n        //         z-index: 2;\n        //       }\n        //       svg {\n        //         &:hover + .tooltip {\n        //           // visibility: visible;\n        //           opacity: 1;\n        //           display: block;\n        //         }\n        //       }\n        // }\n        svg{\n          width: 1.5rem;\n          height: 1.5rem;\n        }\n        // svg {\n        //   cursor: pointer;\n        //   &:hover + .tooltip {\n        //     visibility: visible;\n        //     transition: 1s ease-in;\n        //   }\n        // }\n        .tooltip {\n          position: fixed;\n          display: flex;\n          align-items: center;\n          gap: 0.6rem;\n          // visibility: visible;\n          border: 0.0625rem solid var(--AccentColor);\n          background-color: var(--Foreground);\n          z-index: 999;\n          border-radius: 0.625rem;\n          width: 20rem;\n          height: 6rem;\n          padding: .3125rem;\n          transform: translateY(-110%);\n          transition: 1s ease-in;\n          h3 {\n            font-size: 0.8rem;\n            color: var(--TextColor);\n            font-weight: 700;\n          }\n          p {\n            font-size: 0.7rem;\n            color: var(--TextColor);\n            // text-wrap: pretty;\n            font-weight: 500;\n          }\n\n          img {\n            width: 5rem;\n            height: 5rem;\n            object-fit: contain;\n          }\n          &::after {\n            content: \"\";\n            position: absolute;\n            bottom: -8px;\n            left: 1rem;\n            transform: translateX(50%);\n            width: 0;\n            height: 0;\n            border-left: 0.5rem solid transparent;\n            border-right: 0.5rem solid transparent;\n            border-top: 10px solid var(--Foreground);\n          }\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            bottom: -10px;\n            left: 1rem;\n            transform: translateX(50%);\n            width: 0;\n            height: 0;\n            border-left: 0.5rem solid transparent;\n            border-right: 0.5rem solid transparent;\n            border-top: 10px solid var(--AccentColor);\n          }\n        }\n      }\n    }\n  }\n  .planContainer {\n    height: 100%;\n    flex: 3 40rem 30rem;\n\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: visible;\n    position: relative;\n    gap: 0.6rem;\n    .proceedButton{\n      background-color: var(--AccentColor);\n      height: 3rem;\n      border-radius: 0.5rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #ffffff;\n      gap: 0.5rem;\n      font-size: 1.1rem;\n      position: sticky;\n      top: 0;\n      display: none;\n    }\n    .planInnerContainer{\n      width: 100%;\n      height: 100%;\n      flex: 1;\n      display: flex;\n      padding: 0.6rem;\n      flex-direction: column;\n      gap: .6rem;\n      border: 0.0625rem solid var(--Stroke);\n    border-radius: 0.6rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n      .searchBox {\n        padding-right: 0.75rem;\n        display: flex;\n        width: 100%;\n        min-height: 2.5rem;\n        align-items: center;\n        justify-content: space-between;\n        background-color: var(--Foreground);\n        border-radius: 0.5rem;\n        input {\n          border: none;\n          outline: none;\n          background-color: transparent;\n          flex: 1;\n          padding: 0 0.75rem;\n          height: 100%;\n          color: var(--TextColor);\n          &::placeholder {\n            font-size: 0.9rem;\n          }\n        }\n        img {\n          max-width: 1.25rem;\n          max-height: 1.25rem;\n        }\n      }\n      .planTypesContainer {\n        flex: 1;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        gap: .6rem;\n        .planTypesWrapper{\n          flex: 1;\n          width: 100%;\n          overflow: auto;\n          .planTypes {\n            width: 100%;\n            columns: 3;\n            column-gap: 1rem;\n            overflow: auto;\n          }\n        }\n      }\n    }\n    \n  }\n}\n\n.VeriSavedContainer {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 10;\n  .VeriSaved {\n    padding: 1.25rem 3.75rem;\n    background: var(--Foreground);\n    border-radius: 0.5rem;\n    max-width: 37.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.25rem;\n    .SuccessBeginVerification {\n      max-width: 18.75rem;\n      max-height: 18.75rem;\n      img {\n        width: 100%;\n        height: 100%;\n      }\n    }\n    h1 {\n      font-size: 1.125rem;\n      font-weight: 700;\n      color: var(--TextColor);\n    }\n    .Hint {\n      font-size: 0.875rem;\n      text-align: center;\n      color: var(--TextColor);\n    }\n    .CopyOpen {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 2.5rem;\n      button {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        gap: 0.25rem;\n        color: var(--AccentColor);\n        cursor: pointer;\n        width: 7.5rem;\n        height: 2rem;\n        border-radius: 0.5rem;\n        a {\n          text-decoration: none;\n        }\n      }\n      button:hover {\n        background: #00000009;\n      }\n    }\n    .ButtonContainer {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n      gap: 2.5rem;\n      .Cancel {\n        font-size: 0.875rem;\n        height: 2.5rem;\n        width: 7.5rem;\n        color: #979797;\n        border: 0.0625rem solid #979797;\n        border-radius: 0.5rem;\n        background: transparent;\n        cursor: pointer;\n      }\n      .Cancel:hover {\n        background: #ececec;\n        color: var(--AccentColor);\n      }\n      .Done {\n        font-size: 0.875rem;\n        height: 2.5rem;\n        width: 7.5rem;\n        color: #fff;\n        border: 0.0625rem solid var(--AccentColor);\n        border-radius: 0.5rem;\n        background: var(--AccentColor);\n        border: 0.0625rem solid var(--AccentColor);\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n@media (max-width: 1160px) {\n  .planDetails {\n    .planContainer {\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 940px) {\n  .planDetails {\n    .planContainer {\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .planDetails {\n    .cDetails {\n      height: auto;\n      .proceedBtn{\n        display: none;\n      }\n    }\n    .planContainer {\n      height: auto;\n      .proceedButton{\n        display: flex;\n      }\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 800px) {\n  .planDetails {\n    .cDetails {\n      height: 100%;\n      .proceedBtn{\n        display: none;\n      }\n    }\n    .planContainer {\n      height: 100%;\n      .proceedButton{\n        display: flex;\n      }\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 718px) {\n  .planDetails {\n    .cDetails {\n      height: auto;\n      .proceedBtn{\n        display: none;\n      }\n    }\n    .planContainer {\n      height: auto;\n      \n      .proceedButton{\n        display: flex;\n      }\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .planDetails {\n    .planContainer {\n      .planInnerContainer{\n        .planTypesContainer {\n          .planTypesWrapper{\n            .planTypes {\n              columns: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
